/** biome-ignore-all lint/style/useNamingConvention: legacy */
export enum LOGIN_FAILURE_REASONS {
  BLOCKED = 'blocked',
}
